export default function l(json: any, field: string, lang = "az"): any {
    return json[`${field}_${lang}`];
}